import { Injectable } from '@angular/core';
import { UsuarioLogado } from '../../seguranca/usuario/usuario-logado.model';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  private readonly AUTH_TOKEN = 'authToken';
  private readonly TENANT = 'tenant';
  private readonly ID_USUARIO = 'idUsuario';
  private readonly USUARIO_LOGADO = 'usuarioLogado';
  private readonly PRIMEIRO_ACESSO = 'primeiroAcesso';

  setAuthToken(token: string): void {
    localStorage.setItem(this.AUTH_TOKEN, token);
    sessionStorage.setItem(this.AUTH_TOKEN, token);
  }

  getAuthToken(): string {
    return localStorage.getItem(this.AUTH_TOKEN) || sessionStorage.getItem(this.AUTH_TOKEN);
  }

  setTenant(tenant: string): void {
    localStorage.setItem(this.TENANT, tenant);
  }

  getTenant(): string {
    return localStorage.getItem(this.TENANT);
  }

  setIdUsuario(idUsuario: number): void {
    localStorage.setItem(this.ID_USUARIO, idUsuario.toString());
  }

  getIdUsuario(): number {
    const id = localStorage.getItem(this.ID_USUARIO);
    return id ? parseInt(id, 10) : null;
  }

  setUsuarioLogado(usuario: UsuarioLogado): void {
    localStorage.setItem(this.USUARIO_LOGADO, JSON.stringify(usuario));
    sessionStorage.setItem(this.USUARIO_LOGADO, JSON.stringify(usuario));
  }

  getUsuarioLogado(): UsuarioLogado {
    const usuarioStr = localStorage.getItem(this.USUARIO_LOGADO) || sessionStorage.getItem(this.USUARIO_LOGADO);
    if (usuarioStr) {
      try {
        return JSON.parse(usuarioStr);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  setPrimeiroAcesso(valor: boolean): void {
    localStorage.setItem(this.PRIMEIRO_ACESSO, valor.toString());
  }

  getPrimeiroAcesso(): boolean {
    const valor = localStorage.getItem(this.PRIMEIRO_ACESSO);
    return valor === 'true';
  }

  isLoggedIn(): boolean {
    return this.getAuthToken() != null;
  }

  clear(): void {
    localStorage.removeItem(this.AUTH_TOKEN);
    localStorage.removeItem(this.TENANT);
    localStorage.removeItem(this.ID_USUARIO);
    localStorage.removeItem(this.USUARIO_LOGADO);
    localStorage.removeItem(this.PRIMEIRO_ACESSO);

    sessionStorage.removeItem(this.AUTH_TOKEN);
    sessionStorage.removeItem(this.USUARIO_LOGADO);
  }
}
